import { createContext, useContext, useState } from "react";

const DataContext = createContext({
  errors: {},
  setErrors: () => {},
});

export const DataProvider = ({ children }) => {
  const [errors, setErrors] = useState({});

  return (
    <DataContext.Provider
      value={{
        errors,
        setErrors,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useDataContext = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error("useDataContext must be used within a DataProvider");
  }
  return context;
};

export default DataContext;
